import { render, staticRenderFns } from "./TopupModal.vue?vue&type=template&id=52513346&scoped=true&"
import script from "./TopupModal.vue?vue&type=script&lang=js&"
export * from "./TopupModal.vue?vue&type=script&lang=js&"
import style0 from "./TopupModal.vue?vue&type=style&index=0&id=52513346&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52513346",
  null
  
)

export default component.exports